// store/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    isPageNotFound: false,
    isShowRegisterPage: false,
    webinarSlug: '',
  },
  reducers: {
    setPageNotFound(state, action) {
      state.isPageNotFound = action.payload;
    },
    setShowWebinarRegisterPage(state, action) {
      state.isShowRegisterPage = action.payload;
    },
    setWebinarSlug(state, action) {
      state.webinarSlug = action.payload;
    },
  },
});

export const { setPageNotFound,setShowWebinarRegisterPage,setWebinarSlug } = uiSlice.actions;
export default uiSlice.reducer;
